<template>
  <div class="lee-star-evaluate" :style="'--initColor:'+initColor+';--hoverColor:'+hoverColor">
    <div class="shape" :class="[{active:on>=inx+1},typeStyle]" @mouseover="mouseover(inx)" @mouseout="mouseout" @click="setcur(inx)"
         v-for="(item,inx) in num" :key="item"></div>
  </div>
</template>
<script>
export default {
    name: 'LeeStarEvaluate',
    inheritAttrs: false,
    data() {
        return {
            on: 0
        };
    },
    mounted() {

    },
    computed:{
        typeStyle(){
            return{
                face:this.type==='face',
                star:this.type==='star',
                love:this.type==='love'||'',
            }

        }
    },
    props: {
        value: {
            type: Number,
            default: 0 //默认1
        },
        num: {
            type: Number,
            default: 5 //默认1
        },
        type: {
            type: String,
            default: 'love'
        },
        initColor: {
            type: String,
            default: '#ccc'
        },
        hoverColor: {
            type: String,
            default: '#46bd87'
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.on=value
            }
        },
    },
    methods: {
        mouseover(i) {
            this.on = i + 1
        },
        mouseout() {
            this.on = this.value
        },
        setcur(i) {
            this.$emit('change', i + 1)
            this.$emit('input', i + 1)
        }
    }
};
</script>
<style scoped>
.lee-star-evaluate {
  display: flex;
  align-items: center;
}

.lee-star-evaluate .shape {
  width: 40px;
  height: 40px;
  cursor: pointer;
  overflow: hidden;
  background-size: cover;
  background: var(--initColor);
  transition: .3s;
}
.lee-star-evaluate .face{
  -webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1024 1024'%3E %3Cpath d='M1024 512c0 282.773-229.227 512-512 512S0 794.773 0 512 229.227 0 512 0s512 229.227 512 512zM268.992 269.653a82.197 82.197 0 1 0 0 164.416 82.197 82.197 0 0 0 0-164.416z m486.016 0a82.197 82.197 0 1 0 0 164.416 82.197 82.197 0 0 0 0-164.416z m-22.101 360.32C712 725.504 614.293 820.523 512.49 820.523s-205.526-95.019-226.432-190.55c0 0-6.72-28.309-32.918-28.309-22.101 0-21.93 28.31-21.93 28.31 21.888 135.637 139.477 239.231 281.28 239.231 141.824 0 259.413-103.594 281.28-239.232 0 0 6.314-28.309-19.968-28.309-31.147 0-40.896 28.31-40.896 28.31z'%3E%3C/path%3E %3C/svg%3E") center / 80% no-repeat;
}
.lee-star-evaluate .star{
  -webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1024 1024'%3E %3Cpath d='M781.186088 616.031873q17.338645 80.573705 30.59761 145.848606 6.119522 27.537849 11.219124 55.075697t9.689243 49.976096 7.649402 38.247012 4.079681 19.888446q3.059761 20.398406-9.179283 27.027888t-27.537849 6.629482q-5.099602 0-14.788845-3.569721t-14.788845-5.609562l-266.199203-155.027888q-72.414343 42.836653-131.569721 76.494024-25.498008 14.278884-50.486056 28.557769t-45.386454 26.517928-35.187251 20.398406-19.888446 10.199203q-10.199203 5.099602-20.908367 3.569721t-19.378486-7.649402-12.749004-14.788845-2.039841-17.848606q1.01992-4.079681 5.099602-19.888446t9.179283-37.737052 11.729084-48.446215 13.768924-54.055777q15.298805-63.23506 34.677291-142.788845-60.175299-52.015936-108.111554-92.812749-20.398406-17.338645-40.286853-34.167331t-35.697211-30.59761-26.007968-22.438247-11.219124-9.689243q-12.239044-11.219124-20.908367-24.988048t-6.629482-28.047809 11.219124-22.438247 20.398406-10.199203l315.155378-28.557769 117.290837-273.338645q6.119522-16.318725 17.338645-28.047809t30.59761-11.729084q10.199203 0 17.848606 4.589641t12.749004 10.709163 8.669323 12.239044 5.609562 10.199203l114.231076 273.338645 315.155378 29.577689q20.398406 5.099602 28.557769 12.239044t8.159363 22.438247q0 14.278884-8.669323 24.988048t-21.928287 26.007968z'%3E%3C/path%3E %3C/svg%3E") center / 80% no-repeat;
}
.lee-star-evaluate .love{
  -webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1024 1024'%3E %3Cpath d='M1024.549 360.609c0-170.492-133.815-309.265-298.055-309.265-81.129 0-157.91 34.998-213.344 94.701-55.509-59.702-132.367-94.701-213.344-94.701C135.49 51.344 1.751 190.041 1.751 360.609c0 5.719 0.534 10.827 0.991 15.021-0.076 1.373-0.152 2.745-0.152 4.194 0 30.193 7.319 63.361 21.73 98.59 0.458 1.295 0.915 2.516 1.449 3.657 90.812 217.844 440.412 468.474 455.279 479.985 9.227 7.092 20.205 10.6 31.263 10.6 11.209 0 22.266-3.659 31.566-10.903 12.733-9.911 310.941-224.551 429.279-427.603 4.498-6.861 7.854-13.494 10.828-19.215 0.914-1.829 1.753-3.658 2.744-5.413l0.382-0.839c0.382-0.686 0.839-1.449 1.296-2.059 7.091-13.802 12.732-26.611 17.232-39.116 12.274-32.177 18.3-60.847 18.3-87.61 0-2.058-0.077-3.888-0.229-5.414C1024.093 370.979 1024.549 366.251 1024.549 360.609z'%3E%3C/path%3E %3C/svg%3E") center / 80% no-repeat;
}
.lee-star-evaluate .shape:hover,.lee-star-evaluate .shape.active {
  background: var(--hoverColor);
}

</style>



// WEBPACK FOOTER //
// node_modules/leevueplugin/src/LeeStarEvaluate.vue